import { I18n } from '@aws-amplify/core';

import type { ActionPlanStatus } from './types';

export function getPriorityOptions() {
	return [
		{ label: I18n.get('High'), value: 1 },
		{ label: I18n.get('Medium'), value: 2 },
		{ label: I18n.get('Low'), value: 3 }
	];
}

export const INVESTMENT_LEVELS = [1, 2, 3];

export const KIM_LHC_TABLE_NAME = 'kim_lhc_reports';
export const KIM_LHC_ORIGIN_NAME = 'KIM LHC';
export const ACTION_PLAN_DEFAULT_STATUS = 'TO DO' as const;
export const ACTION_PLAN_PAGE_SIZE = 1;

export const ACTION_PLAN_STATUS_CONFIG: Record<ActionPlanStatus, { color: string; label: string }> = {
	'TO DO': { color: '#2F54EB', label: 'To Do' },
	DOING: { color: '#F0AE00', label: 'Doing' },
	DONE: { color: '#2CC852', label: 'Done' }
};
